<template>
    <div>
        <div class="space-web visible-lg visible-md"></div>
        <div class="space-mobil visible-xs visible-sm"></div>
        <!-- Termina Space -->

        <!-- Buscador Movil -->
        <div class="container back-black">
            <div class="row">
                <div class="col-sm-12">
                    <!-- <div class="busqueda-contenido3 visible-sm visible-xs">
                        <form role="form" @submit.prevent="simpleSearch" method="get" >
                            <ul class="list-inline">
                                <li style="width: 77%;"><input v-model="simpleSearchInput"  @keyup="getList"  autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                                <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                                <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada2"><i class="fa fa-plus"></i></button></li>
                                <div class="autocomplete home-movil" v-show="isOpen" >
                                    <ul class="autocomplete-results">
                                        <li v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                            {{ result.nameRecord }}
                                        </li>
                                    </ul>
                                </div>
                            </ul>

                            <div class="radio-ww animated slideInRight visible-sm visible-xs">
                                <label class="radio-inline">
                                    <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="ww">Who's Who
                                    </label>
                                <label class="radio-inline">
                                    <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="guia">OTT
                                </label>
                            </div>
                        </form>
                    </div> -->
                    <!-- <div class="busq-avanzada">
                        <div id="busqavanzada2" class="collapse">
                            <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <select class="form-control" name="country" v-model="countryIn"  >
                                          <option :value="0" selected >-- País --</option>
                                          <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                          <option  :value="0"  selected >-- Categoría --</option>
                                          <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <select class="form-control" name="activity" v-model="activityIn" >
                                            <option  :value="0"  selected >-- Actividad --</option>
                                            <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                        </select>
                                    </div>
                                </div>
                              </form>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- Carrusel Top -->
        <div class="carrusel-top">
            <div class="visible-lg visible-md animated slideInDown" align="center" style="padding: 25px 0px;">
                <div id="sas_31458"></div>
            </div>
            <div class="carousel ">
                <div id="myCarousel" class="carousel slide" data-ride="carousel" >
                    <!-- Indicators -->
                    <ol class="carousel-indicators">
                        <li v-for="(contact, index) in contacts" :key="index" data-target="#myCarousel" :data-slide-to="index" :class="{ active: index === 0 }"></li>
                    </ol>

                    <!-- Wrapper for slides -->
                    <div class="carousel-inner">
                        <div v-for="(tmpCont,index) in contacts" :key="index" :class="'item '+((index == 0 ) ? 'active' : '')"  >
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-6" align="center">
                                        <div class="img-persona-top">
                                            <div class=" imagen-persona-top animated zoomInRight">
                                                <router-link  :to="'/contacto/'+tmpCont.permalink_contacto" >
                                                    <div class="feat-image" :style="{ 'background-image': getImageUrl(tmpCont.Images) }"  ></div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="info-persona-top">
                                            <!-- <form class="buscador-slider visible-lg visible-md" @submit.prevent="simpleSearch" method="get" >

                                                <div class="input-group animated zoomInRight">
                                                    <input type="text" class="form-control" v-model="simpleSearchInput"  @keyup="getList" @focus="stopCarousel" placeholder="Buscar en el Who's Who...">
                                                    <div class="input-group-btn">
                                                        <a @click.prevent="simpleSearch"  class="btn btn-default btn-buscar" type="submit">
                                                            <i class="fa fa-search"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="autocomplete home" v-show="isOpen" >
                                                    <ul class="autocomplete-results">
                                                        <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                                            {{ result.nameRecord }}
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="radio-ww animated slideInRight">
                                                    <label class="radio-inline">
                                                    <input type="radio" v-model="selectedSearchIn"  v-on:change="getList"   value="ww">Who's Who
                                                    </label>
                                                    <label class="radio-inline">
                                                    <input type="radio" v-model="selectedSearchIn"  v-on:change="getList" value="guia">OTT
                                                    </label>
                                                </div>
                                            </form> -->
                                            <!-- <a href="" data-toggle="modal" data-target="#ModalBusquedaAvanzada"><p class="animated slideInRight visible-lg visible-md"> Búsqueda Avanzada <i class="fa fa-angle-down"></i></p></a> -->
                                            <h1 class="animated slideInRight" v-html="tmpCont.Rubro"></h1>
                                            <hr class="linea-degradado visible-xs visible-sm animated zoomInRight">
                                            <router-link  :to="'/contacto/'+tmpCont.permalink_contacto" >
                                                <h2 class="animated zoomInRight" v-html="tmpCont.FirstName+' '+tmpCont.LastName" ></h2>
                                            </router-link>
                                            <router-link  :to="'/contacto/'+tmpCont.permalink_contacto" >
                                                <h3 class="animated zoomInRight" v-html="tmpCont.Title" ></h3>
                                            </router-link>
                                            <router-link  :to="'/empresa/'+tmpCont.permalink_empresa" >
                                                <h3 class="animated zoomInRight" v-html="tmpCont.CompanyName" ></h3>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Left and right controls -->
                      <!-- <a class="carousel-control visible-lg visible-md" href="#myCarousel" data-slide="pause" ref="controlCarouselPause">
                    </a> -->
                    <a class="left carousel-control visible-lg visible-md" href="#myCarousel" data-slide="prev">
                        <span class="glyphicon glyphicon-chevron-left"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="right carousel-control visible-lg visible-md" href="#myCarousel" data-slide="next">
                        <span class="glyphicon glyphicon-chevron-right"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
                <div class="visible-lg visible-md animated slideInDown" align="center">
                    <div id="sas_31461" class="footer-banner">
                    </div>
                </div>
            </div>
        </div>

         <!-- Modal Busqueda Avanzada Web -->
         <!-- <div class="modal  fade" id="ModalBusquedaAvanzada" role="dialog">
            <div class="modal-dialog busq_avanzada_web">
                <div class="modal-content">
                    <div class="modal-header" align="center">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Búsqueda Avanzada</h4>
                    </div>
                    <div class="modal-body" align="center">
                        <div class="row">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-10">
                                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get">
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="country" v-model="countryIn"  >
                                                <option :value="0" selected >-- País --</option>
                                                <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                                <option  :value="0"  selected >-- Categoría --</option>
                                                <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="activity" v-model="activityIn" >
                                                <option  :value="0"  selected >-- Actividad --</option>
                                                <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12" >
                                            <button type="button" @click.prevent="advanceSearch"  class="btn " data-dismiss="modal">BUSCAR</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-sm-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    const resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';
    const flowBridgeAPIBase = process.env.FLOWBRIDGE_URL;

    import axios from 'axios';

    export default {
        name: 'Topslider',
        data() {
            return {
                contacts: [],
                imageBackground: require('../../assets/images/bg_persona2.png'),
                simpleSearchInput: '',
                countries: [],
                categories: [],
                activities: [],
                categoryIn: 0,
                contactoIn: '',
                empresaIn: '',
                countryIn: 0,
                activityIn: 0,
                selectedSearchIn: 'ww',
                isOpen: false,
                contactos: [],
                permalink: 0,
                nombres: '',
                bannerTop: sas.call('std', {
                    siteId: 69989, //
                    pageId: 540425, // Página : Produ.com/wwtelemundointernacional
                    formatId: 31458, // Formato : wwAbajo_1 1000x150
                    target: '', // Segmentación
                }),
                bannerFooter: sas.call('std', {
                    siteId: 69989, //
                    pageId: 540425, // Página : Produ.com/wwtelemundointernacional
                    formatId: 31461, // Formato : wwAbajo_1 1000x150
                    target: '', // Segmentación
                }),
            };
        },
        created() {},
        methods: {
            getContactsBySectionsWWFWS: async function() {

                await axios.get(flowBridgeAPIBase + 'contacts', {
                    params: {
                        home_slider: true,
                        include_in_wiw: true,
                        fields: 'featured_image,company,who'
                    }
                }).then(response => {
                    // Ordenar por who.home_slider ascendente
                    const sortedContacts = (response.data.data || []).sort((a, b) => {
                        const posA = (a.who && a.who.home_slider) ? a.who.home_slider : 999999;
                        const posB = (b.who && b.who.home_slider) ? b.who.home_slider : 999999;
                        return posA - posB;
                    });

                    const processedContacts = sortedContacts.map(contact => {
                        // Extraer datos de company con prioridad a primary
                        const companyData = (contact.company && contact.company.primary) ? contact.company.primary : (contact.company || {});

                        return {
                            IdContactFM: contact.post_id,
                            FirstName: contact.name.trim(),
                            LastName: contact.last_name.trim(),
                            Title: companyData.position || '',
                            Biografia: contact.biography || '',
                            Images: contact.featured_image.url,
                            IdCompanyFM: companyData.id || '',
                            CompanyName: companyData.name || '',
                            CompanyWWSection: contact.who && contact.who.categories && contact.who.categories[0] && contact.who.categories[0].name
                                                ? contact.who.categories[0].name
                                                : '',
                            permalink_contacto: contact.slug,
                            permalink_empresa: companyData.slug || '',
                            Rubro: contact.who && contact.who.categories && contact.who.categories[0] && contact.who.categories[0].name
                                                ? contact.who.categories[0].name
                                                : '',
                        };
                    });
                    this.contacts = processedContacts;

                    this.$nextTick(function() {});
                });
            },

            isActiveSearch() {
                return !this.selectedSearchIn || this.simpleSearchInput.length <= 0
                    ? false
                    : true;
            },
            simpleSearch: function(e) {
                if (this.simpleSearchInput && this.isActiveSearch()) {
                    this.nombres =
                        this.nombres == '' ? this.simpleSearchInput : this.nombres;
                    this.$router.push({
                        name: 'Search',
                        params: {
                            permalink: this.permalink,
                            tipo: this.selectedSearchIn,
                            search: this.simpleSearchInput,
                            nombres: this.nombres,
                        },
                    });
                }
            },
            advanceSearch: async function() {
                $('#myModalHome').modal('hide');
                this.$router.push(
                    '/advancesearch/' +
                        this.contactoIn +
                        '_' +
                        this.empresaIn +
                        '_' +
                        this.countryIn +
                        '_' +
                        this.categoryIn +
                        '_' +
                        this.activityIn
                );
            },

            getDataModal: async function() {
                await axios
                    .post(resfulApi + 'getCountriesWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    })
                    .then(response => {
                        this.countries = response.data.countries;
                        this.categories = response.data.categories;

                        this.$nextTick(function() {});
                    });

                this.getActivity();
            },

            getActivity: async function() {
                this.activityIn = 0;
                if (this.categoryIn) {
                    await axios
                        .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                            category: this.categoryIn,
                        })
                        .then(response => {
                            this.activities = response.data;
                            this.$nextTick(function() {});
                        });
                }
            },
            getList: function() {
                this.simpleSearchInput.length > 3
                    ? this.getSearchWWFWS()
                    : (this.isOpen = false);
            },
            stopCarousel: function() {
                var refCarousel = this.$refs.controlCarouselPause;
                refCarousel.click();
            },
            getSearchWWFWS: async function() {
                await axios
                    .post(resfulApi + 'getSearchWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        search: this.simpleSearchInput,
                        tipo: this.selectedSearchIn,
                    })
                    .then(response => {
                        this.contactos = response.data;
                        this.contactos.length > 0
                            ? (this.isOpen = true)
                            : (this.isOpen = false);
                    });
            },
            setResult: async function(result) {
                this.simpleSearchInput = result.nombres;
                this.permalink = result.permalink;
                this.nombres = result.nombres;
                this.isOpen = false;
                var typeSearch = this.redirectConsulta(
                    result.nameRecord,
                    result.GuiaOTT
                );
                this.$router.push('/' + typeSearch + '/' + result.permalink);
            },
            getImageUrl: function(imageData) {
                // Si es una URL directa (string)
                if (typeof imageData === 'string' && imageData.startsWith('https')) {
                    return `url('${imageData}')`;
                }
                // Si es JSON, usar la función del mixin
                return this.getVerticalContact(imageData, true);
            },
        },
        beforeMount() {},
        mounted: function() {
            this.getContactsBySectionsWWFWS();
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a:hover {
        cursor: pointer;
    }

    .scroll_container {
        overflow: auto;
        overflow-x: hidden;
    }

    .home-img-responsive {
        margin: 0px auto;
        /*border-radius: 50%;*/
    }

    @media only screen and (max-width: 650px) {
        .home_section_title h1 {
            display: block;
            font-family: 'Open Sans', sans-serif;
            font-size: 28px;
            color: #ffffff;
            font-weight: 500;
            line-height: 1.1;
            animation: fadeInUp 300ms linear 300ms both;
            letter-spacing: 2px;
            text-align: center;
        }

        .slide-margin .carousel-content h2,
        h3,
        a,
        button {
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/Topslider.vue